import finalBackground from 'assets/images/backgrounds/base_final_reward.png';
import baseBackground from 'assets/images/backgrounds/base_reward.png';
import matmanCompletedSrc from 'assets/images/MatMan/MatMan_Activities_Completed.png';
import { NewRewardData, StickersCount } from 'types';
import { matManImage } from './mat-man-image-util';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';

const t = (key: string, options?) => translate('rewards', key, options);

export const getNewRewardData = (character: string): { [key in StickersCount]: NewRewardData } => ({
  [StickersCount.FIRST]: {
    backgroundImage: baseBackground,
    matManImageSrc: matManImage[character],
    title: t('earnedFirstStickerTitle'),
    summary: t('earnedFirstStickerSummary', {
      character: `${character}${character.toLowerCase()}`,
    }),
  },
  [StickersCount.SECOND]: {
    backgroundImage: baseBackground,
    matManImageSrc: matManImage[character],
    title: t('earnedAnotherStickerTitle'),
    summary: t('earnedAnotherStickerSummary'),
  },
  [StickersCount.THIRD]: {
    backgroundImage: finalBackground,
    matManImageSrc: matmanCompletedSrc,
    title: t('earnedLastStickerTitle'),
    summary: t('earnedLastStickerSummary', {
      character: `${character}${character.toLowerCase()}`,
    }),
  },
});
